import React, { useState, useContext } from "react";
import appLogo from "../assets/img/app_logo.png";
import Person from "../components/Person";
import { AuthContext } from "../contexts/AuthContext";
import { changeImage, deleteImage } from "../services/my-profile";
import { BsTrash } from "react-icons/bs";
import { FaCamera } from "react-icons/fa";

export default function ProfileHead({
  image,
  prenom,
  nom,
  username,
  poste,
  userId,
  colors,
}) {
  const { user, setUser } = useContext(AuthContext);
  const [displayBtn, setDisplayBtn] = useState(false);
  const [formDatas, setFormDatas] = useState(null);
  const [displayTextSuccess, setDisplayTextSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const handleFileChange = (event) => {
    const fichier = event.target.files[0];
    if (fichier) {
      const formData = new FormData();
      formData.append("image", fichier);
      setFormDatas(formData);
      setDisplayBtn(true);
    }
  };

  return (
    <>
      <div className={`tyn-profile-head `}>
        <div className="tyn-profile-cover d-flex justify-content-center">
          <img
            className="tyn-profile-cover-image my-tyn-logo"
            src={appLogo}
            alt="app_logo"
          />
        </div>

        <div className="tyn-profile-info">
          <div className="tyn-media-group align-items-start">
            <div
              className="tyn-media tyn-media-bordered tyn-size-4xl tyn-profile-avatar"
              style={{ position: "relative" }}
            >
              <label
                htmlFor={user.username === username ? `userImage` : ""}
                style={{ cursor: "pointer", height: "80px", width: "80px" }}
                className={
                  user.username === username ? "my-card-profile-img" : ""
                }
              >
                <Person
                  person={{
                    image,
                    nom,
                    prenom,
                    userId,
                    colors,
                  }}
                  animate="animate__animated animate__pulse animate__infinite"
                />
                {user.username === username && (
                  <span className="my-card-profile-button">
                    <FaCamera />
                  </span>
                )}
              </label>
              <input
                type="file"
                id="userImage"
                accept="image/*,.gif,.jpeg,.jpg,.webp,png"
                style={{ display: "none" }}
                onChange={(evt) => {
                  handleFileChange(evt);
                }}
              />
              {user.username === username && image && (
                <button
                  className="btn text-danger"
                  style={{
                    position: "absolute",
                    top: "-3px",
                    right: 0,
                  }}
                  onClick={async () => {
                    const result = await deleteImage();
                    if (result && result.status === 200) {
                      setUser(result.userData);
                      setDisplayBtn(false);
                      setSuccessMsg("Image supprimée avec succès.");
                      setDisplayTextSuccess(true);
                      setTimeout(() => setDisplayTextSuccess(false), 5000);
                    }
                  }}
                >
                  <BsTrash
                    style={{
                      height: "25px",
                      width: "25px",
                    }}
                  />
                </button>
              )}
            </div>
            <div className="tyn-media-col">
              <div className="tyn-media-row">
                <h2 className="name" style={{ fontSize: "15px" }}>
                  {prenom + " " + nom}{" "}
                  <span className="username" style={{ fontSize: "15px" }}>
                    {username}
                  </span>
                </h2>
              </div>

              {/* <div className="tyn-media-row has-dot-sap">
                <span className="content">3 Contacts</span>
                <span className="meta">8 Groupes</span>
              </div> */}
              <div className="tyn-media-row has-dot-sap">
                <span className="content">{poste}</span>
              </div>
              {displayBtn ? (
                <>
                  <button
                    className="btn btn-outline-primary col-12"
                    onClick={async () => {
                      const result = await changeImage(user, formDatas);
                      if (result && result.status === 200) {
                        setUser(result.userData);
                        setSuccessMsg("L'image a été modifiée avec succès.");
                        setDisplayTextSuccess(true);
                        setTimeout(() => setDisplayTextSuccess(false), 5000);
                      }
                      setDisplayBtn(false);
                      setFormDatas(null);
                    }}
                  >
                    Changer
                  </button>
                </>
              ) : displayTextSuccess ? (
                <p className="text-success">{successMsg}</p>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
